export const Points = (pointTotal) => (pointTotal === 1 ? "point" : "points")

export const Ordinal = (number) => {
  const n = parseInt(number, 10)
  const s = ["th", "st", "nd", "rd"]
  const v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}
